var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "informationStation" } }, [
    !_vm.closeOffline && _vm.isOffline
      ? _c("div", { staticClass: "v3offline" }, [
          _c("i", { staticClass: "icon-exclamation-mark-circle" }),
          _vm._v(" "),
          _c("p", [_vm._v("未連接至網路")]),
          _vm._v(" "),
          _c("div", { on: { click: _vm.closeOfflineHandle } }, [
            _c("i", { staticClass: "icon-close" })
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mainContentTopMenu mainContentTopMenuFixed" },
      [
        _c(
          "swiper",
          {
            ref: "articleTypeSwiper",
            staticClass: "articleTypeSwiper",
            attrs: { options: _vm.articleTypeSwiperParams }
          },
          _vm._l(_vm.articleType, function(tag, tag_ind) {
            return _c(
              "swiper-slide",
              {
                key: tag_ind,
                class: { selected: tag_ind === _vm.whichTypeIndexIsChoose }
              },
              [
                _c("span", [
                  _c(
                    "p",
                    {
                      on: {
                        click: function($event) {
                          _vm.selectTypeByMenu(tag_ind)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(tag.type_name) +
                          "\n            "
                      )
                    ]
                  )
                ])
              ]
            )
          })
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "articleTypeSwiperMask",
            class: _vm.hiddenMenuIsOpen ? "show" : "hide"
          },
          [_vm._v("選擇分類")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "articleTypeMenuButton",
            class: { active: _vm.hiddenMenuIsOpen },
            on: { click: _vm.articleTypeMenuButtonHandle }
          },
          [_c("i", { staticClass: "icon-arrow-down" })]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "articleTypeMenu",
            class: _vm.hiddenMenuIsOpen ? "show" : "hide"
          },
          _vm._l(_vm.articleType, function(tag, tag_ind) {
            return _c(
              "div",
              {
                key: tag_ind,
                class: { selected: tag_ind === _vm.whichTypeIndexIsChoose },
                on: {
                  click: function($event) {
                    _vm.selectTypeByMenu(tag_ind)
                  }
                }
              },
              [
                _vm._v(
                  "\n            " + _vm._s(tag.type_name) + "\n          "
                )
              ]
            )
          })
        ),
        _vm._v(" "),
        _c("div", {
          staticClass: "mask",
          class: _vm.hiddenMenuIsOpen ? "show" : "hide",
          on: { click: _vm.articleTypeMenuButtonHandle }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "swiper-container swiperPages", attrs: { id: "Pages" } },
      [
        _c(
          "swiper",
          {
            ref: "articleSwiper",
            staticClass: "articleSwiper",
            attrs: { options: _vm.articleSwiperParams }
          },
          _vm._l(_vm.articleType, function(tag, tag_ind) {
            return _c(
              "swiper-slide",
              { key: tag_ind, attrs: { news_type: tag.type_id } },
              [
                _c(
                  "transition",
                  { attrs: { name: "fade" } },
                  [
                    _c(
                      "mescroll-vue",
                      {
                        ref: "mescroll",
                        refInFor: true,
                        attrs: {
                          down: _vm.getMescrollDown(tag_ind),
                          up: _vm.getMescrollUp(tag_ind)
                        },
                        on: {
                          init: function($event) {
                            _vm.mescrollInit(tag_ind, arguments)
                          }
                        }
                      },
                      [
                        _c("div", { staticClass: "articleList" }, [
                          _vm.article[tag_ind]
                            ? _c(
                                "ul",
                                [
                                  _vm._l(_vm.article[tag_ind].list, function(
                                    news,
                                    news_ind
                                  ) {
                                    return [
                                      _c(
                                        "li",
                                        { key: news_ind },
                                        [
                                          _c(
                                            "router-link",
                                            {
                                              attrs: {
                                                to: {
                                                  name: "v3newsDetail",
                                                  params: { id: news.news_id }
                                                }
                                              }
                                            },
                                            [
                                              _c(
                                                "span",
                                                { staticClass: "articleTag" },
                                                [_vm._v(_vm._s(news.news_type))]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "articleContent"
                                                },
                                                [
                                                  news.title_img !== ""
                                                    ? _c("div", {
                                                        directives: [
                                                          {
                                                            name: "lazy",
                                                            rawName:
                                                              "v-lazy:background-image",
                                                            value:
                                                              news.title_img,
                                                            expression:
                                                              "news.title_img",
                                                            arg:
                                                              "background-image"
                                                          }
                                                        ],
                                                        staticClass:
                                                          "articleContentImg"
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  news.title_img == ""
                                                    ? _c("div", {
                                                        staticClass:
                                                          "articleContentImg"
                                                      })
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "articleContentNote"
                                                    },
                                                    [_vm._v(_vm._s(news.title))]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "articleContentIcon"
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "icon-right-roundedline"
                                                      })
                                                    ]
                                                  )
                                                ]
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      news_ind !== 0 && news_ind % 10 === 0
                                        ? _c(
                                            "li",
                                            {
                                              key: "ad-" + news_ind,
                                              staticStyle: { padding: "0" }
                                            },
                                            [
                                              [
                                                _c("script2", {
                                                  attrs: {
                                                    type: "text/javascript",
                                                    async: "true",
                                                    src:
                                                      "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c("ins", {
                                                  staticClass: "adsbygoogle",
                                                  staticStyle: {
                                                    display: "block"
                                                  },
                                                  attrs: {
                                                    "data-ad-format": "fluid",
                                                    "data-ad-layout-key":
                                                      "-h2+k-m-92+j4",
                                                    "data-ad-client":
                                                      "ca-pub-9449560331897859",
                                                    "data-ad-slot": "9748661614"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "script2",
                                                  {
                                                    attrs: {
                                                      type: "text/javascript"
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      " (adsbygoogle = window.adsbygoogle || []).push({}); "
                                                    )
                                                  ]
                                                )
                                              ]
                                            ],
                                            2
                                          )
                                        : _vm._e()
                                    ]
                                  })
                                ],
                                2
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.article[tag_ind].loading &&
                          _vm.article[tag_ind].list.length === 0
                            ? _c("div", { staticClass: "articleListEmpty" }, [
                                _c("i", { staticClass: "icon-empty-status" }),
                                _vm._v(" "),
                                _c("p", [_vm._v("此類別目前尚無文章")])
                              ])
                            : _vm._e()
                        ])
                      ]
                    )
                  ],
                  1
                )
              ],
              1
            )
          })
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.v3Toast.show,
            expression: "v3Toast.show"
          }
        ],
        staticClass: "v3Toast"
      },
      [_vm._v(_vm._s(_vm.v3Toast.text))]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f2d4812", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f2d4812","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/v3/news.vue
// module id = null
// module chunks = 